/*
    Local storage keys
    suffix with LSK
*/
export const JWT_LSK = 'jwt';
export const REFRESH_LSK = 'refresh-token';
export const CURRENT_LOCALE_LSK = 'i18nextLng';

/*
    Session storage keys
    suffix with SSK
*/
